import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sentInvoiceOrg", "billingContentCode", "applyDescription"]

  connect() {
    this.handleBillingContentCodeChange = this.handleBillingContentCodeChange.bind(this)
    this.updateApplyDescription = this.updateApplyDescription.bind(this)
    this.billingContentCodeTarget.addEventListener('change', this.handleBillingContentCodeChange)

    const updateApplyDescription = this.updateApplyDescription
    $(this.billingContentCodeTarget).selectize({
      plugins: ["remove_button"],
      respect_word_boundaries: false,
      onChange: function() {
        updateApplyDescription()
      }
    });

    $(this.sentInvoiceOrgTarget).selectize({
      plugins: ["remove_button"],
      respect_word_boundaries: false,
      onChange: function(value) {
        updateApplyDescription()
        if (!value.length) return;

        const sent_invoice_org_change_url = `/financial_analysis/other_billing_and_inquiries/sent_invoice_org_change?sent_invoice_org_code=${encodeURIComponent(value)}`
        $.ajax(sent_invoice_org_change_url, {
          dataType: 'script'
        });
      }
    });

    this.updateApplyDescription()
  }

  disconnect() {
    this.billingContentCodeTarget.removeEventListener('change', this.handleBillingContentCodeChange)
  }

  handleBillingContentCodeChange() {
    this.updateApplyDescription()
  }

  updateApplyDescription() {
    if (this.billingContentCodeTarget.value === "S00004") {
      this.applyDescriptionTarget.value = "设计咨询费"
      this.applyDescriptionTarget.readOnly = true
    } else if (this.billingContentCodeTarget.value === "S00025" && this.sentInvoiceOrgTarget.value === "000117") {
      this.applyDescriptionTarget.value = "S00025"
      this.applyDescriptionTarget.readOnly = true
    } else {
      if (this.applyDescriptionTarget.value === "设计咨询费" || this.applyDescriptionTarget.value === "S00025") {
        this.applyDescriptionTarget.value = ""
      }
      this.applyDescriptionTarget.readOnly = false
    }
  }
}
